import './simpleLightbox/simpleLightbox.css';
import LightboxExtension from "./js/LightboxExtension";
export default LightboxExtension;
